var module = angular.module('octopusApp.users');

module.controller('RegisterController', function($scope, $location, $stateParams, busy, octopusAuthenticator, octopusRepository, octopusPermissionSet, octopusFeatures) {
    var isSubmitting = $scope.isSubmitting = busy.create();

    if (octopusAuthenticator.currentUser()) {
        $location.path('/');
        return;
    }

    var invitation = $stateParams['invitation'];

    var fields = $scope.fields = {
        username: '',
        displayName: '',
        emailAddress: '',
        password: '',
        confirmPassword: '',
        invitation: invitation
    };

    $scope.invitationRequired = !(invitation) || invitation.length !== 33;

    $scope.register = function() {
        if (fields.password !== fields.confirmPassword) {
            isSubmitting.showError('The passwords you entered do not match');
            return;
        }

        var go = octopusRepository.Users.register({
            Username: fields.username,
            DisplayName: fields.displayName,
            EmailAddress: fields.emailAddress,
            Password: fields.password,
            InvitationCode: fields.invitation,
            IsActive: true
        });

        var redirect = go.then(function(user) {
            octopusAuthenticator.currentUser(user);
            octopusPermissionSet.refresh();
            octopusFeatures.refresh();
            $location.path('/');
        });

        isSubmitting.promise(redirect);
    };


});







//////////////////
// WEBPACK FOOTER
// ./app/areas/users/controllers/register_controller.js
// module id = 7745508482687598
// module chunks = 1